import { IonCard, IonCardContent } from "@ionic/react";
import { useHistory, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import WithFab from "../../../hoc/with-fab";
import WithNavigation from "../../../hoc/with-navigation";
import { home } from "ionicons/icons";
import TvmForm from "../../../components/common/tvm-form";
import { useSystem } from "../../../store/system";
import { useEffect } from "react";
import { printNumber } from "../../../utils/helpers";
import { TvmFormSubmitResult } from "../../../components/common/tvm-form/form-definition";

import "./styles.css";


const FORM_ID = "resistenceExpansion";

interface ResistenceExpansionResult {
	guincheResult: number | null;
}

const ResistenceExpansion = () => {
	const { systemId } = useParams<any>();
	const history = useHistory();

	const systemStore = useSystem();

	const { t } = useTranslation();

	const updateResults = (
		data: TvmFormSubmitResult<ResistenceExpansionResult>
	) => {
		systemStore.submitFormResult(systemId, FORM_ID, data);
	};

	useEffect(() => {
		systemStore.loadForm(FORM_ID);
		systemStore.loadFormResult(systemId, FORM_ID);
	}, []);

	return (
		<>
			<WithNavigation
				hintsContent={{
					title: systemStore.currentForm?.hints.title,
					htmlDef: systemStore.currentForm?.hints?.htmlDef || "",
				}}
				preventGoBack={false}
				text={t("system.trawlGates.title")}
			>
				<div className="form">
					{systemStore.currentForm && (
						<>
							{systemStore.formResultReqInfo?.finished && (
								<TvmForm
									title={t("system.trawlGates.resistanceExpansion.subtitle")}
									systemName={systemId}
									definition={systemStore.currentForm}
									fieldValues={systemStore.currentFormValues}
									onSubmit={updateResults}
								/>
							)}
							{
								<IonCard>
									<IonCardContent>
										<div className="ion-text-center">
											<h5 className="calcResultTitle">{t("general.results")}</h5>
											<div className="result-row">
												<p className="label">
													{t("system.trawlGates.resistanceExpansion.resistance")}
												</p>
												<p className="row-value">
													{systemStore.formFlags?.saltwater ?
														printNumber(systemStore.formResult?.trawlGateResistanceSA) :
														printNumber(systemStore.formResult?.trawlGateResistanceSW)
													}
												</p>
												<p>[kgf]</p>
											</div>
											<div className="result-row">
												<p className="label">
													{t("system.trawlGates.resistanceExpansion.expansion")}
												</p>
												<p className="row-value">
													{systemStore.formFlags?.saltwater ?
														printNumber(systemStore.formResult?.trawlGateExpansionSA) :
														printNumber(systemStore.formResult?.trawlGateExpansionSW)
													}
												</p>
												<p>[kgf]</p>
											</div>
										</div>
									</IonCardContent>
								</IonCard>
							}
						</>
					)}
				</div>
			</WithNavigation>
		</>
	);
};

export default ResistenceExpansion;
